import {Component, Input} from '@angular/core';
import {ApexOptions} from 'ng-apexcharts';

@Component({
  selector: 'app-widget-gauge-chart',
  templateUrl: './widget-gauge-chart.component.html',
  styleUrls: ['./widget-gauge-chart.component.scss'],
  standalone: false
})
export class WidgetGaugeChartComponent {

  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() chartColor: string = '#3880ff';

  @Input() data: number | null = null;
  @Input() percentage: number | string | null = null;
  @Input() stateStats: string = 'success';
  @Input() iconStats: string = '';

  @Input() subData: number | null = null;
  @Input() subDataPercentage: number | string | null = null;
  @Input() subDataStateStats: string = 'success';
  @Input() subDataIconStats: string = '';

  chartOptions: ApexOptions = {
    chart: {
      height: 150,
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '75%'
        },
        track: {
          background: '#e9e9e9',
          strokeWidth: '60%',
          margin: 0,
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: true,
            offsetY: 8,
            fontSize: '22px',
            fontWeight: 600,
            formatter: ((val: number) => val?.toFixed(1) + '%')
          }
        }
      }
    },
    stroke: {
      show: false,
      lineCap: 'round'
    },
    labels: ['']
  };

}
